import React from 'react';
import { Input } from 'reactstrap';

const LONG_TEXT = 60;

const TextField = ({ field, value, onChange, disabled }) => {
  const stringValue = value == null ? '' : value;
  const isLong = String(stringValue).length > LONG_TEXT;

  return (
    <Input
      type={isLong ? 'textarea' : 'text'}
      name={field.key}
      placeholder={field.label}
      value={stringValue}
      disabled={disabled}
      onChange={(e) => onChange(field.key, e.target.value)}
      style={{ maxWidth: '500px' }}
    />
  );
};

export default TextField;
